import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 48 48"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M33.151 26.375a3.5 3.5 0 0 0 .004-4.78L23.228 10.96a3 3 0 0 0-5.193 2.045l-.014 21.937a3 3 0 0 0 5.19 2.052zM20.035 13.006a1 1 0 0 1 1.731-.682l9.927 10.636a1.5 1.5 0 0 1-.002 2.049l-9.94 10.618a1 1 0 0 1-1.73-.684z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "mask",
    {
      id: "Arrow-Right-Outlined_svg__a",
      width: 17,
      height: 28,
      x: 18,
      y: 10,
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse"
    },
    /* @__PURE__ */ React.createElement(
      "path",
      {
        fill: "#fff",
        fillRule: "evenodd",
        d: "M33.151 26.375a3.5 3.5 0 0 0 .004-4.78L23.228 10.96a3 3 0 0 0-5.193 2.045l-.014 21.937a3 3 0 0 0 5.19 2.052zM20.035 13.006a1 1 0 0 1 1.731-.682l9.927 10.636a1.5 1.5 0 0 1-.002 2.049l-9.94 10.618a1 1 0 0 1-1.73-.684z",
        clipRule: "evenodd"
      }
    )
  ),
  /* @__PURE__ */ React.createElement("g", { mask: "url(#Arrow-Right-Outlined_svg__a)" }, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M0 0h48v48H0z" }))
);
var SvgArrowRightOutlined = styled(SvgComponent)`
  ${size}
  ${color}
`;
var ArrowRightOutlined_default = SvgArrowRightOutlined;

export { ArrowRightOutlined_default as default };
